const BUTTON_AUTH = ['08000104', '08000105', '08000106', '08000107', '08000108', '08000124'];

export default {
    configuration: true,
    'buttonList': [
        {
            'type': 'text',
            'icon': 'el-icon-search',
            'class': 'bigData-btn-tf-search',
            'label': '查询',
            'size': 'small',
            'event': 'search',
            'ifHas': BUTTON_AUTH[0]
        },
        {
            'type': 'text',
            'icon': 'el-icon-circle-plus-outline',
            'class': 'bigData-btn-tf-add',
            'label': '新增',
            'size': 'small',
            'event': 'add',
            'ifHas': BUTTON_AUTH[1]
        },
        {
            'type': 'text',
            'icon': 'el-icon-refresh',
            'class': 'bigData-btn-tf-change',
            'label': '更新',
            'size': 'small',
            'event': 'refresh',
            'ifHas': BUTTON_AUTH[5]
        },
        {
            'type': 'text',
            'icon': 'el-icon-user',
            'class': 'bigData-btn-tf-personPay',
            'label': '个人注册美的付',
            'size': 'small',
            'event': 'register'
        },
        {
            'type': 'text',
            'icon': 'el-icon-user',
            'class': 'bigData-btn-tf-legalPay',
            'label': '法人注册美的付',
            'size': 'small',
            'event': 'legal-register'
        },
        {
            'type': 'text',
            'icon': 'el-icon-delete',
            'class': 'bigData-btn-tf-del',
            'label': '删除',
            'size': 'small',
            'event': 'deleteData',
        },
    ],
    'table': {
        'switchType': true,
        'tableCut': false,
        'clickState': false,
        'selectBtn': true,
        'height': 'calc(100vh - 215px)',
        'statesY': '启用',
        'statesN': '停用',
        'columns': [
            {
                'label': '银行账户',
                'prop': 'bankAccount',
                'width': '180px'
            },
            {
                'label': '账户名',
                'prop': 'bankAccountName',
                'width': '150px'
            },
            {
                'label': '账户类型',
                'prop': 'accountType_',
                'width': '120px'
            },
            {
                'label': '审批状态',
                'prop': 'approvalStatus_',
                'width': '150px'
            },
            {
                'label': '开户行名称',
                'prop': 'bankName',
                'width': '150px'
            },
            {
                'label': '开户行编号',
                'prop': 'bankCode',
                'width': '150px'
            },
            {
                'label': '联行号',
                'prop': 'ubankNo',
                'width': '150px'
            },
            {
                'label': '开户行地址',
                'prop': 'bankAddress',
                'width': '180px'
            },
            {
                'label': '账户状态',
                'prop': 'accountFlag',
                'width': '100px'
            },
            {
                'label': '是否保理',
                'prop': 'factorageFlag',
                'width': '100px'
            },
            {
                'label': '币种',
                'prop': 'accountCurrencyName',
                'width': '100px'
            },
            {
                'label': '创建人',
                'prop': 'createUserName',
                'width': '120px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': '150px'
            },
            {
                'label': '变更人',
                'prop': 'updateUserName',
                'width': '120px'
            }
        ],
        'action': [
            {
                'type': 'text',
                'label': '预览',
                'size': 'mini',
                'event': 'preview',
                'ifHas': BUTTON_AUTH[2]
            },
            {
                'type': 'text',
                'label': '下载',
                'size': 'mini',
                'event': 'download',
                'ifHas': BUTTON_AUTH[3]
            },
            {
                'type': 'text',
                'label': '变更',
                'size': 'mini',
                'event': 'change',
                'ifHas': BUTTON_AUTH[4]
            }
        ],
        'leftOperation': true,
        'leftWidth': 250
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};
